// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.loader-container[data-v-f8da5e5a] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  opacity: 0.5;\n  -webkit-opacity: 0.5;\n  -moz-opacity: 0.5;\n  filter: alpha(opacity=50);\n  z-index: 1000;\n}\n.loader-content[data-v-f8da5e5a] {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n", ""]);
// Exports
module.exports = exports;
